module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "free-offer-top-panel"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.refreshEnabled
    },
    on: {
      "click": function($event) {
        return _vm.getFreeOffers()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("refresh")]), _vm._v(" "), (!_vm.isSmallScreen) ? [_c('br'), _vm._v("\n            " + _vm._s(_vm.lang.SFO000) + "\n          ")] : _vm._e()], 2), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.selectedFreeOfferGuid
    },
    on: {
      "click": function($event) {
        return _vm.openFreeOfferDetailsDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("info_outline")]), _vm._v(" "), (!_vm.isSmallScreen) ? [_c('br'), _vm._v("\n            " + _vm._s(_vm.lang.SFO001) + "\n          ")] : _vm._e()], 2), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    on: {
      "click": function($event) {
        return _vm.openFreeOfferFilterChecksDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("filter_list")]), _vm._v(" "), (!_vm.isSmallScreen) ? [_c('br'), _vm._v("\n            " + _vm._s(_vm.lang.SFO016) + "\n          ")] : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-xs-6 col-md-4"
  }, [_c('div', {
    staticClass: "form-group searchbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Search),
      expression: "filterStrings.Search"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "search",
      "id": "inputSearch",
      "placeholder": _vm.lang.SFO002
    },
    domProps: {
      "value": (_vm.filterStrings.Search)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getFreeOffers()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Search", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-2"
  }, [(_vm.filterOptions.CurrentLocation) ? _c('a', {
    staticClass: "btn",
    attrs: {
      "role": "button",
      "id": "orderByDistanceButton"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('Distance')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.SFO025) + "\n          "), (_vm.showSortArrow('Distance', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : (_vm.showSortArrow('Distance', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _c('span', {
    staticClass: "glyphicon glyphicon-sort"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-xs-12 nopadding"
  }, [_c('ul', {
    staticClass: "pagination-fonts pagination btn-group"
  }, [_c('li', [_vm._m(0), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "elementsPerPageDropdown",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SFO004))]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 20
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 20)
      }
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 50
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 50)
      }
    }
  }, [_vm._v("50")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 100
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 100)
      }
    }
  }, [_vm._v("100")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 200
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 200)
      }
    }
  }, [_vm._v("200")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 500
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 500)
      }
    }
  }, [_vm._v("500")])])])], 1), _vm._v(" "), _c('li', {
    class: {
      disabled: _vm.selectedPage == 1
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 0)
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "firstPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SFO005))])], 1), _vm._v(" "), (_vm.pageCount > 7 && _vm.selectedPage > 4) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getVisiblePages()), function(pageNumber) {
    return _c('li', {
      key: pageNumber,
      class: {
        active: _vm.selectedPage == pageNumber
      },
      on: {
        "click": function($event) {
          return _vm.updatePaging(pageNumber, 0)
        }
      }
    }, [_c('a', {
      attrs: {
        "role": "button"
      }
    }, [_vm._v(_vm._s(pageNumber))])])
  }), _vm._v(" "), (_vm.pageCount > 7 && _vm.selectedPage < _vm.pageCount - 3) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      disabled: _vm.selectedPage == _vm.pageCount
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(_vm.pageCount, 0)
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "lastPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SFO006))])], 1), _vm._v(" "), _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button",
      "id": "freeOfferTotalElementsCounter"
    }
  }, [_vm._v(_vm._s(_vm.checkCount))]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "freeOfferTotalElementsCounter",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SFO024))])], 1)], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "freeofferstable"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "table-space main-table-scrollbar"
  }, [_c('table', {
    staticClass: "table table-striped table-hover main-table"
  }, [_c('thead', [_c('tr', [(!_vm.isSmallScreen) ? _c('th', {
    staticClass: "text-center sticky-header",
    staticStyle: {
      "width": "8%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('SurveyInstanceId')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SFO008) + "\n                  "), (_vm.showSortArrow('SurveyInstanceId', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('SurveyInstanceId', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header",
    style: (("width:" + (_vm.isSmallScreen ? '25' : '13') + "%;"))
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('SurveyTitle')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.isSmallScreen ? _vm.lang.SFO017 : _vm.lang.SFO012) + "\n                  "), (_vm.showSortArrow('SurveyTitle', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('SurveyTitle', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), (!_vm.isSmallScreen) ? _c('th', {
    staticClass: "text-center sticky-header",
    staticStyle: {
      "width": "30%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('SurveyInstanceDescription')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SFO011) + "\n                  "), (_vm.showSortArrow('SurveyInstanceDescription', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('SurveyInstanceDescription', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.isSmallScreen) ? _c('th', {
    staticClass: "text-center sticky-header",
    staticStyle: {
      "width": "15%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('LocationPostalCode')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SFO018) + "\n                  "), (_vm.showSortArrow('LocationPostalCode', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('LocationPostalCode', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (!_vm.isSmallScreen) ? _c('th', {
    staticClass: "text-center sticky-header",
    staticStyle: {
      "width": "6%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('LocationCity')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SFO018) + "\n                  "), (_vm.showSortArrow('LocationCity', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('LocationCity', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (!_vm.isSmallScreen) ? _c('th', {
    staticClass: "text-center sticky-header",
    staticStyle: {
      "width": "6%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('LocationPostalCode')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SFO022) + "\n                  "), (_vm.showSortArrow('LocationPostalCode', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('LocationPostalCode', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (!_vm.isSmallScreen) ? _c('th', {
    staticClass: "text-center sticky-header",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('LocationCountry')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SFO023) + "\n                  "), (_vm.showSortArrow('LocationCountry', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('LocationCountry', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (!_vm.isSmallScreen) ? _c('th', {
    staticClass: "text-center sticky-header",
    staticStyle: {
      "width": "8%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('ScenarioName')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SFO020) + "\n                  "), (_vm.showSortArrow('ScenarioName', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('ScenarioName', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header",
    staticStyle: {
      "width": "8%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('SurveyInstanceInfo')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SFO021) + "\n                  "), (_vm.showSortArrow('SurveyInstanceInfo', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('SurveyInstanceInfo', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), (!_vm.isSmallScreen) ? _c('th', {
    staticClass: "text-center sticky-header",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('LocationAdditionalInfo')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SFO019) + "\n                  "), (_vm.showSortArrow('LocationAdditionalInfo', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('LocationAdditionalInfo', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header",
    style: (("width:" + (_vm.isSmallScreen ? '15' : '7') + "%;"))
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('SurveyInstanceSince')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SFO009) + "\n                  "), (_vm.showSortArrow('SurveyInstanceSince', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('SurveyInstanceSince', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header",
    style: (("width:" + (_vm.isSmallScreen ? '15' : '7') + "%;"))
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('SurveyInstanceUntil')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SFO010) + "\n                  "), (_vm.showSortArrow('SurveyInstanceUntil', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('SurveyInstanceUntil', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header",
    style: (("width:" + (_vm.isSmallScreen ? '15' : '8') + "%;"))
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('TotalPayment')
      }
    }
  }, [(!_vm.isSmallScreen) ? [_vm._v(_vm._s(_vm.lang.SFO013))] : _c('i', {
    staticClass: "material-icons md-20"
  }, [_vm._v("euro_symbol")]), _vm._v(" "), (_vm.showSortArrow('TotalPayment', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('TotalPayment', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()], 2)])]), _vm._v(" "), (_vm.globals.isLargeScreen()) ? _c('tr', {
    staticClass: "table-filters"
  }, [_c('th', {
    staticClass: "nopadding sticky-filter",
    staticStyle: {
      "width": "8%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyInstanceId),
      expression: "filterStrings.SurveyInstanceId"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SFO003
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyInstanceId)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getFreeOffers()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyInstanceId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter",
    staticStyle: {
      "width": "13%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyTitle),
      expression: "filterStrings.SurveyTitle"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SFO003
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyTitle)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getFreeOffers()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyTitle", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter",
    staticStyle: {
      "width": "14%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyInstanceDescription),
      expression: "filterStrings.SurveyInstanceDescription"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SFO003
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyInstanceDescription)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getFreeOffers()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyInstanceDescription", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter",
    staticStyle: {
      "width": "6%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationCity),
      expression: "filterStrings.LocationCity"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SFO003
    },
    domProps: {
      "value": (_vm.filterStrings.LocationCity)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getFreeOffers()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationCity", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter",
    staticStyle: {
      "width": "6%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationPostalCode),
      expression: "filterStrings.LocationPostalCode"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SFO003
    },
    domProps: {
      "value": (_vm.filterStrings.LocationPostalCode)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getFreeOffers()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationPostalCode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationCountry),
      expression: "filterStrings.LocationCountry"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SFO003
    },
    domProps: {
      "value": (_vm.filterStrings.LocationCountry)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getFreeOffers()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationCountry", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter",
    staticStyle: {
      "width": "8%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ScenarioName),
      expression: "filterStrings.ScenarioName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SFO003
    },
    domProps: {
      "value": (_vm.filterStrings.ScenarioName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getFreeOffers()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ScenarioName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter",
    staticStyle: {
      "width": "8%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyInstanceInfo),
      expression: "filterStrings.SurveyInstanceInfo"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SFO003
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyInstanceInfo)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getFreeOffers()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyInstanceInfo", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationAdditionalInfo),
      expression: "filterStrings.LocationAdditionalInfo"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SFO003
    },
    domProps: {
      "value": (_vm.filterStrings.LocationAdditionalInfo)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getFreeOffers()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationAdditionalInfo", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter",
    staticStyle: {
      "width": "7%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyInstanceSince),
      expression: "filterStrings.SurveyInstanceSince"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SFO003
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyInstanceSince)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getFreeOffers()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyInstanceSince", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter",
    staticStyle: {
      "width": "7%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyInstanceUntil),
      expression: "filterStrings.SurveyInstanceUntil"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SFO003
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyInstanceUntil)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getFreeOffers()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyInstanceUntil", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter",
    staticStyle: {
      "width": "8%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.TotalPayment),
      expression: "filterStrings.TotalPayment"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SFO003
    },
    domProps: {
      "value": (_vm.filterStrings.TotalPayment)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getFreeOffers()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "TotalPayment", $event.target.value)
      }
    }
  })])])]) : _vm._e()]), _vm._v(" "), _c('tbody', {
    staticClass: "main-table-scrollbar"
  }, _vm._l((_vm.freeOffers), function(freeOffer) {
    return _c('tr', {
      key: freeOffer.SurveyInstanceGuid,
      staticClass: "text-center",
      class: {
        info: freeOffer.SurveyInstanceGuid === _vm.selectedFreeOfferGuid,
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          _vm.selectedFreeOfferGuid = freeOffer.SurveyInstanceGuid
        },
        "dblclick": function($event) {
          return _vm.openFreeOfferDetailsDialog()
        }
      }
    }, [(!_vm.isSmallScreen) ? _c('td', {
      staticStyle: {
        "width": "8%"
      }
    }, [_vm._v("\n                " + _vm._s(freeOffer.SurveyInstanceId) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('td', {
      style: (("width:" + (_vm.isSmallScreen ? '25' : '13') + "%;"))
    }, [_vm._v("\n                " + _vm._s(freeOffer.SurveyTitle) + "\n                "), (freeOffer.LocationFree) ? _c('i', {
      staticClass: "material-icons",
      class: {
        'md-18': !_vm.isSmallScreen, 'md-24': _vm.isSmallScreen
      }
    }, [_vm._v("location_off")]) : _vm._e()]), _vm._v(" "), (!_vm.isSmallScreen) ? _c('td', {
      staticStyle: {
        "width": "16%"
      },
      attrs: {
        "id": "freeOfferDescription"
      }
    }, [_vm._v("\n                " + _vm._s(_vm.globals.truncateString(
      _vm.globals.getMarkupText(
        freeOffer.SurveyInstanceDescription
      ),
      50
    )) + "\n              ")]) : _vm._e(), _vm._v(" "), (!_vm.isSmallScreen) ? _c('td', {
      staticStyle: {
        "width": "7%"
      }
    }, [_vm._v("\n                " + _vm._s(freeOffer.LocationCity) + "\n              ")]) : _vm._e(), _vm._v(" "), (!_vm.isSmallScreen) ? _c('td', {
      staticStyle: {
        "width": "7%"
      }
    }, [_vm._v("\n                " + _vm._s(freeOffer.LocationPostalCode) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.isSmallScreen) ? _c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v("\n                " + _vm._s(freeOffer.LocationPostalCode) + "\n                " + _vm._s(freeOffer.LocationCity) + "\n              ")]) : _vm._e(), _vm._v(" "), (!_vm.isSmallScreen) ? _c('td', {
      staticStyle: {
        "width": "5%"
      }
    }, [_vm._v("\n                " + _vm._s(freeOffer.LocationCountry) + "\n              ")]) : _vm._e(), _vm._v(" "), (!_vm.isSmallScreen) ? _c('td', {
      staticStyle: {
        "width": "8%"
      }
    }, [_vm._v("\n                " + _vm._s(freeOffer.ScenarioName) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "8%"
      }
    }, [_vm._v("\n                " + _vm._s(freeOffer.SurveyInstanceInfo) + "\n              ")]), _vm._v(" "), (!_vm.isSmallScreen) ? _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v("\n                " + _vm._s(_vm.globals.truncateString(
      _vm.globals.getMarkupText(freeOffer.LocationAdditionalInfo),
      50
    )) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('td', {
      style: (("width:" + (_vm.isSmallScreen ? '15' : '7') + "%;"))
    }, [_vm._v("\n                " + _vm._s(freeOffer.SurveyInstanceSince) + "\n              ")]), _vm._v(" "), _c('td', {
      style: (("width:" + (_vm.isSmallScreen ? '15' : '7') + "%;"))
    }, [_vm._v("\n                " + _vm._s(freeOffer.SurveyInstanceUntil) + "\n              ")]), _vm._v(" "), _c('td', {
      style: (("width:" + (_vm.isSmallScreen ? '15' : '8') + "%;"))
    }, [_vm._v("\n                " + _vm._s(_vm.globals.getCurrencyString(freeOffer.TotalPayment, "EUR")) + "\n              ")])])
  }), 0)])])])]), _vm._v(" "), _c('FreeOfferDetailsDialog', {
    attrs: {
      "showDialog": _vm.showFreeOfferDetailsDialog,
      "freeOffer": _vm.selectedFreeOffer
    },
    on: {
      "dialogClosed": _vm.closeFreeOfferDetailsDialog,
      "freeOfferAccepted": _vm.onFreeOfferAccepted
    }
  }), _vm._v(" "), _c('FreeOfferFilterChecksDialog', {
    attrs: {
      "showDialog": _vm.showFreeOfferFilterChecksDialog
    },
    on: {
      "dialogClosed": _vm.closeFreeOfferFilterChecksDialog,
      "filterChecks": _vm.onFilterChecks
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "role": "button",
      "data-toggle": "dropdown",
      "id": "elementsPerPageDropdown"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("view_headline")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "firstPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("first_page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "lastPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("last_page")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c6d4a146","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FreeOffers/FreeOffers.vue
// module id = 421
// module chunks = 1 2